var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.recommendList.length > 0
    ? _c(
        "div",
        {
          staticClass: "fancafe_recommend",
          attrs: { id: "fancafe_recommend" },
        },
        [
          _c(
            "div",
            { staticClass: "inner_recommend", attrs: { id: "recommend" } },
            [
              _c("div", { staticClass: "group_panel" }, [
                _c("div", { staticClass: "recommend_title cafe" }, [
                  _c("span", { staticClass: "txt_state" }, [
                    _vm._v(_vm._s(_vm.recommendSet.label)),
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticClass: "tit_recommend" }, [
                    _vm._v(_vm._s(_vm.recommendSet.subject1)),
                    _c("em", [_vm._v(_vm._s(_vm.recommendSet.subject2))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wrap_btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn_g btn_prev",
                      class: { btn_disabled: !_vm.hasPrev },
                      attrs: { id: "recommendPrev" },
                      on: { click: _vm.prev },
                    },
                    [
                      _c("span", { staticClass: "ico_cafetop" }, [
                        _vm._v("이전 보기"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn_g btn_next",
                      class: { btn_disabled: !_vm.hasNext },
                      attrs: { id: "recommendNext" },
                      on: { click: _vm.next },
                    },
                    [
                      _c("span", { staticClass: "ico_cafetop" }, [
                        _vm._v("다음 보기"),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wrap_list" }, [
                _c(
                  "ul",
                  { staticClass: "track_list", attrs: { id: "recommendList" } },
                  _vm._l(_vm.recommendList, function (recommend, index) {
                    return _c(
                      "recommend-item",
                      _vm._b(
                        { key: "recommend-" + index },
                        "recommend-item",
                        recommend,
                        false
                      )
                    )
                  }),
                  1
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }